import React__default from 'react';
import { useEvent } from 'react-use-event-hook';

const useControlledState = ({ defaultValue, value: controlledValue, onChange, }) => {
    const [uncontrolledValue, setUncontrolledValue] = React__default.useState(defaultValue);
    const controlled = controlledValue !== undefined;
    const value = controlled ? controlledValue : uncontrolledValue;
    const setValue = useEvent((nextValue) => {
        if (!controlled) {
            setUncontrolledValue(nextValue);
        }
        onChange?.(nextValue);
    });
    return [value, setValue];
};

export { useControlledState };
